import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.class';
import {BaseItemBrightnessOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-brightness-option';
import {useAppSelector} from '@/hooks';

export function ImageBgBrightnessOption(): ReactElement<any> | null {
  const currentPageObject = useAppSelector(getCurrentPage);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageObject) {
    return null;
  }

  if (currentPageObject.background.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  const updateBrightness = (brightness: number, undoable = true): void => {
    void currentPage?.background.updateFromObject(
      {
        details: {
          imageBackgroundItemObject: {
            effects: {
              brightness,
            },
          },
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemBrightnessOption brightness={currentPageObject.background.details.imageBackgroundItemObject.effects.brightness} updateBrightness={updateBrightness} />;
}
